import { createStorefrontClient } from '@shopify/hydrogen-react';

export const storefrontClient = createStorefrontClient({
  storeDomain: process.env.REACT_APP_SHOPIFY_STORE_DOMAIN || '',
  storefrontApiVersion: process.env.REACT_APP_SHOPIFY_STORE_API_VERSION || '2024-07',
  publicStorefrontToken: process.env.REACT_APP_SHOPIFY_STORE_API_PUBLIC_TOKEN || '',
});

type DisplayableErrorKeys =
  | 'cartUserError'
  | 'checkoutUserError'
  | 'customerUserErrors'
  | 'metafieldDeleteUserError'
  | 'metafieldSetUserError'
  | 'userErrors';

const errorKeys: DisplayableErrorKeys[] = [
  'cartUserError',
  'checkoutUserError',
  'customerUserErrors',
  'metafieldDeleteUserError',
  'metafieldSetUserError',
  'userErrors',
];

interface DisplayableError {
  field: string[];
  message: string;
}

export class StorefrontApiClientError extends Error {
  errors: DisplayableError[];
  statusCode: number;
  constructor(message, errors, statusCode) {
    super(message);
    this.errors = errors;
    this.statusCode = statusCode;

    Object.setPrototypeOf(this, StorefrontApiClientError.prototype);
  }
}

export const executeGraphQLQuery = async (query: string, variables = {}) => {
  const response = await fetch(storefrontClient.getStorefrontApiUrl(), {
    body: JSON.stringify({
      query: query,
      variables: variables,
    }),
    headers: storefrontClient.getPublicTokenHeaders(),
    method: 'POST',
  });

  const responseBody = await response.json();
  const code = response.status;

  if (!response.ok) {
    throw new StorefrontApiClientError(response.statusText, [], code);
  }

  checkForDisplayableError(responseBody);

  return responseBody;
};

export const checkForDisplayableError = (response: any): void => {
  const dataKey = Object.keys(response.data || {})[0];
  const foundKey =
    dataKey &&
    errorKeys.find(
      key =>
        typeof response.data[dataKey] !== 'undefined' &&
        response.data[dataKey] &&
        response.data[dataKey][key] !== undefined
    );

  if (foundKey) {
    const errorArray = response.data[dataKey][foundKey];
    if (errorArray && errorArray.length > 0) {
      const firstErrorItem = errorArray[0];

      const firstError: DisplayableError = {
        field: firstErrorItem.field,
        message: firstErrorItem.message,
      };

      throw new StorefrontApiClientError(firstError ? firstError.message : null, errorArray, 200);
    }
  }
};
